(function () {
  const root = document.querySelector("[data-compact-header]");
  if (!root) return;

  const menuToggles = root.querySelectorAll(".js-compact-menu-toggle");
  const panels = root.querySelectorAll(".js-compact-panel");
  const drawer = root.querySelector(".js-compact-drawer");
  const drawerOpenBtn = root.querySelector(".js-compact-drawer-open");
  const drawerCloseBtn = root.querySelector(".js-compact-drawer-close");

  function setExpanded(el, expanded) {
    el.setAttribute("aria-expanded", expanded ? "true" : "false");
    const chevron = el.querySelector(".js-compact-chevron");
    if (chevron) {
      chevron.classList.toggle("is-open", expanded);
    }
  }

  function closeDesktopPanels() {
    menuToggles.forEach((btn) => setExpanded(btn, false));
    panels.forEach((panel) => {
      panel.hidden = true;
      panel.classList.add("hidden!");
    });
  }

  function openDesktopPanel(id) {
    closeDesktopPanels();
    const panel = root.querySelector(`[data-compact-panel-id="${id}"]`);
    const toggle = root.querySelector(`.js-compact-menu-toggle[data-compact-panel="${id}"]`);
    if (!panel || !toggle) return;
    panel.hidden = false;
    panel.classList.remove("hidden!");
    setExpanded(toggle, true);
  }

  function toggleDesktopPanel(id) {
    const toggle = root.querySelector(`.js-compact-menu-toggle[data-compact-panel="${id}"]`);
    if (!toggle) return;
    const isOpen = toggle.getAttribute("aria-expanded") === "true";
    if (isOpen) {
      closeDesktopPanels();
    } else {
      openDesktopPanel(id);
    }
  }

  menuToggles.forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggleDesktopPanel(btn.dataset.compactPanel);
    });
  });

  document.addEventListener("click", (event) => {
    if (!root.contains(event.target)) {
      closeDesktopPanels();
      return;
    }
    const inToggle = event.target.closest(".js-compact-menu-toggle");
    const inPanel = event.target.closest(".js-compact-panel");
    if (!inToggle && !inPanel) {
      closeDesktopPanels();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    closeDesktopPanels();
    if (drawer && !drawer.hidden) {
      closeDrawer();
    }
  });

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    drawer.classList.remove("hidden!");
    document.documentElement.style.overflow = "hidden";
    if (drawerOpenBtn) setExpanded(drawerOpenBtn, true);
    drawerCloseBtn?.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    drawer.classList.add("hidden!");
    document.documentElement.style.overflow = "";

    if (drawerOpenBtn) {
      setExpanded(drawerOpenBtn, false);
      drawerOpenBtn.focus();
    }
  }

  drawerOpenBtn?.addEventListener("click", (event) => {
    event.preventDefault();
    openDrawer();
  });

  drawerCloseBtn?.addEventListener("click", (event) => {
    event.preventDefault();
    closeDrawer();
  });

  root.querySelectorAll(".js-compact-acc-toggle").forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault();
      const panelId = btn.getAttribute("aria-controls");
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;
      const willOpen = btn.getAttribute("aria-expanded") !== "true";
      setExpanded(btn, willOpen);
      panel.hidden = !willOpen;
      panel.classList.toggle("hidden!", !willOpen);
    });
  });
})();
